module.exports = __webpack_public_path__ + "img/IMG_8512_P_L_Black_MockedUp.aa6a1447.jpg";